window.addEventListener('load', () => {
    let parallaxDown = document.querySelectorAll('.rellax-down');
    let parallaxDownHeading = document.querySelectorAll('.rellax-down-heading');
    let parallaxDownSlow = document.querySelectorAll('.rellax-down-slow');
    let parallaxUp = document.querySelectorAll('.rellax-up');

    if (parallaxDown.length) {
        let rellaxDown = new Rellax('.rellax-down', {
            speed: -3,
            verticalScrollAxis: 'y',
            breakpoints: [768, 1280, 1792]
        });
    }

    if (parallaxDownHeading.length) {
        let rellaxDownHeading = new Rellax('.rellax-down-heading', {
            speed: 0,
            verticalScrollAxis: 'y',
            breakpoints: [768, 1280, 1792]
        });
    }

    if (parallaxDownSlow.length) {
        let parallaxDownSlow = new Rellax('.rellax-down-slow', {
            speed: -1,
            verticalScrollAxis: 'y',
            breakpoints: [768, 1280, 1792]
        });
    }

    if (parallaxUp.length) {
        let rellaxUp = new Rellax('.rellax-up', {
            speed: 3,
            verticalScrollAxis: 'y',
            breakpoints: [768, 1280, 1792]
        });
    }
});